<script setup lang="ts">
type Props = {
  iconSize: string | number
  absolute?: boolean
}

withDefaults(defineProps<Props>(), {
  iconSize: 24,
})
</script>

<template>
  <div
    :class="[
      'loader',
      {
        'loader--absolute': absolute,
      },
    ]"
  >
    <div v-for="index in 3" :key="index" class="loader__item">
      <nuxt-img src="/roll-loader.webp" :width="iconSize" :height="iconSize" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes pop-da-pop {
  0%,
  5%,
  95%,
  100% {
    transform: translateY(0);
  }
  40%,
  60% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(-48%);
  }
}

.loader {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);

  &--absolute {
    padding: 18px 14px 4px 14px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  &__item {
    width: max-content;
    height: max-content;
    animation: infinite pop-da-pop 1.3s ease;
  }

  &__item:nth-child(1) {
    animation-delay: 80ms;
  }

  &__item:nth-child(2) {
    animation-delay: 160ms;
  }

  &__item:nth-child(3) {
    animation-delay: 240ms;
  }
}
</style>
